import { useState } from "react";
import httpService from "../services/httpService"; // your axios wrapper

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import { Link } from "react-router-dom";
import Badge from "react-bootstrap/Badge"

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import PublicNavigation from "../components/PublicNavigation";

const Corporate = () => {
    const image = '/img/microphone-black-gray.jpg';
    const image2 = '/img/microphone-computer-black-grey.jpg';
    const image3 = '/img/microphone-square.jpg';
    const image4 = '/img/desk.jpg';
    return (
        <div className={'page corporate'}>
            <div className="page-hero" style={{
                backgroundImage: `url(${image})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover"
            }}>
                <Container className="py-5 align-content-start">
                    <Row>
                        <Col md={6} className={''}>
                            <h1>Turn your Podcast Club into a product companies pay for</h1>
                            <h3>Companies need fresh ways to engage and train their teams. Your podcast can be the spark.</h3>
                            <br/>
                            <Link target={'_blank'} className={'btn btn-primary me-3'} to={'https://calendly.com/skilldingkevin/1stcallpodcaster'}>
                                Plan Your Next Step
                            </Link>
                            <Link className={'btn btn-primary'} to={'/login'}>
                                See Your Podcast Club Demo
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container className={"py-5 switcher"}>
                <Row>
                    <Col md={12} className={'py-5'}>
                        <Row>
                            <Col sm={3}>
                                <Card className={'p-3'}>
                                    <h4>Why corporates care</h4>
                                    <ul>
                                        <li>Most corporate training is forgettable. Leaders want something that sparks real conversation.</li>
                                        <li>Podcasts are easy to listen to, but without a next step they don’t change behaviour.</li>
                                        <li>A Podcast Club turns listening into learning and application.</li>
                                    </ul>
                                </Card>
                            </Col>
                            <Col sm={3}>
                                <Card className={'p-3'}>
                                    <h4>What this means for you</h4>
                                    <p>Selling a Podcast Club into a company means:</p>
                                    <ul>
                                        <li><span className={'bold-colored'}>Direct revenue:</span> get paid for a structured programme, not ad slots.</li>
                                        <li><span className={'bold-colored'}>Credibility:</span> your expertise becomes part of their staff development.</li>
                                        <li><span className={'bold-colored'}>Scalability:</span> one Podcast Club can serve 10 or 500 staff at once.</li>
                                    </ul>
                                </Card>
                            </Col>
                            <Col sm={3}>
                                <Card className={'p-3'}>
                                    <h4>How Podsy helps you do it</h4>
                                    <p>Podsy makes it easy to sell and deliver a Podcast Club to corporate teams.</p>
                                    <ul>
                                        <li><span className={'bold-colored'}>Package</span> a focused set of episodes into a topic-based Podcast Club companies can run with their teams.</li>
                                        <li><span className={'bold-colored'}>Packaging your Podcast Club</span> into a clear offer (timeline, outcomes, price).</li>
                                        <li><span className={'bold-colored'}>Providing the platform</span> to run it smoothly, discussions, Q&A, resources, and start/finish dates.</li>
                                        <li><span className={'bold-colored'}>Supporting delivery</span> so you can focus on the content while the system handles the rest.</li>
                                    </ul>
                                </Card>
                            </Col>
                            <Col sm={3}>
                                <Card className={'p-3'}>
                                    <h4>Example use cases</h4>
                                    <p>Where it works best:</p>
                                    <ul>
                                        <li>A leadership consultant running a Podcast Club inside a bank to spark management conversations.</li>
                                        <li>A sustainability podcaster creating a Podcast Club for a corporate team rolling out ESG initiatives.</li>
                                        <li>A marketing strategist selling a Podcast Club to an agency network as staff development.</li>
                                    </ul>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
            <div className="cta-hero" style={{
                backgroundImage: `url(${image2})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center center",
            }}>
                <Container className="py-5 text-center" style={{}}>
                    <Row>
                        <Col sm={12}>
                            <h1>
                                Your next step
                            </h1>
                            <h2>Make your podcast a product companies want to buy.</h2>
                        </Col>
                        <Col sm={6} className={'py-5'}>
                            <Link target={'_blank'} className={'btn btn-secondary btn-block'} to={'https://calendly.com/skilldingkevin/1stcallpodcaster'}>
                                <h4>Book a Call</h4>
                            </Link>
                        </Col>
                        <Col sm={6} className={'py-5'}>
                            <Link className={'btn btn-secondary btn-block'} to={'/login'}>
                                <h4>Explore with Your RSS Feed</h4>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default Corporate;
